const locales = [
  { label: 'English - United States', locale: 'en_US', format: 'MM/DD/YYYY' },
  { label: 'English - Canada', locale: 'en_CA', format: 'MM/DD/YYYY' },
  { label: 'English - Australia', locale: 'en_AU', format: 'DD/MM/YYYY' },
  { label: 'English - New Zealand', locale: 'en_NZ', format: 'DD/MM/YYYY' },
  { label: 'Spanish - United States', locale: 'es_US', format: 'MM/DD/YYYY' },
  { label: 'Spanish - Mexico', locale: 'es_MX', format: 'DD/MM/YYYY' },
  { label: 'Spanish - Colombia', locale: 'es_CO', format: 'DD/MM/YYYY' },
];

export { locales };
